import ListingHeader from "app/pages/Listing/ListingHeader/ListingHeader";
import { connect } from "react-redux";
import { getListingHeaderMerchandisings } from "app/pages/Merchandising/merchandisingSelector";
import {
	getTopDestinationFilterValues,
	getOngoingProducts,
} from "app/pages/Listing/productsSelector";
import find from "lodash/find";
import { bindActionCreators } from "redux";
import { setListingFilterStickness } from "app/pages/Header/menuActionCreators";
import { checkIfNavlogEnabled } from "app/pages/Listing/NavLogs/navLogsSelector";
import {
	getPaymentDescriptionBlock,
	getPartnerListingHero,
	getShowPfsMessage,
} from "app/reducers/partnerSelector";
import { useEffect } from "react";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import propTypes from "prop-types";

const ListingHeaderContainer = props => {
	const { fetchSDPFilters, partnerListingHero = {} } = props;

	const { displaySmartDPForm = false } = partnerListingHero;

	useEffect(() => {
		if (displaySmartDPForm) {
			fetchSDPFilters();
		}
	}, [displaySmartDPForm]);

	return <ListingHeader {...props} />;
};

ListingHeaderContainer.propTypes = {
	fetchSDPFilters: propTypes.func,
	partnerListingHero: propTypes.object,
};

const mapStateToProps = (state, props) => {
	const products = getOngoingProducts(state);
	const idSpotlight = props.idSpotlight;
	const topDestinationsFilterValues = getTopDestinationFilterValues(state);
	return {
		resolution: state.resolution,
		heroProduct: find(getOngoingProducts(state), product => {
			return product.uri && product.uri === idSpotlight;
		}),
		activeFilters: state.productsFilters,
		topDestinationsFilterValues: topDestinationsFilterValues,
		merchandisingHeader: getListingHeaderMerchandisings(state, idSpotlight).merchList,
		products,
		brand: state.brand.code,
		partnerCode: state.partner.code,
		isNavlogsEnabled: checkIfNavlogEnabled(state),
		marketingBanner: state.partner.marketingBanner,
		showPfsMessage: getShowPfsMessage(state),
		partnerListingHero: getPartnerListingHero(state),
		isPaymentDescriptionBlockExist: Boolean(getPaymentDescriptionBlock(state)),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			setListingFilterStickness,
			fetchSDPFilters,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingHeaderContainer);
